import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminTareasComponent } from './admin-tareas/admin-tareas.component';
import { UsuarioProfileComponent } from './usuario-profile/usuario-profile.component';
import { VcardGeneratorComponent } from './vcard-generator/vcard-generator.component';

const routes: Routes = [
  {
    path: '',
    children: [   
      {
        path: 'AdminTareas',
        component: AdminTareasComponent,
        data: {
          title: 'Administrador Tareas'
        }
      }, 
      {
        path: 'UsuarioProfile',
        component: UsuarioProfileComponent,
        data: {
          title: 'Usuario Profile'
        }
      }, 
      {
        path: 'VcardGenerator',
        component: VcardGeneratorComponent,
        data: {
          title: 'VCard Generator'
        }
      },    
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class GeneralesRoutingModule { }
